import ARB from 'assets/chains/ARB.svg'
import AVAX from 'assets/chains/AVAX.svg'
import BASE from 'assets/chains/BASE.svg'
import ETH from 'assets/chains/ETH.svg'

export const CHAIN_ICONS = {
  ETH,
  AVAX,
  ARB,
  BASE,
}
